import { Router } from './Router.js';
import { newsRoutes } from './routes.news.js';

// get wrapper div for router rending
let wrapper = document.getElementById('newsWrapper');

// get root div for router rendering
let root = document.getElementById('newsMain');

//initialize the router
let npRouter = new Router(wrapper,root,newsRoutes);

window.onload = () => {

    //load initial content
    npRouter.routerNavigate(window.location.pathname,true);

    //initialize router links
    npRouter.initRouterLinks();

    //handles back and forward in browser history
    window.onpopstate = function(event) {
        npRouter.routerNavigate(window.location.pathname,false);
        //updateBreadcrumbs();
    };
}
